import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import VueCurrencyFilter from "vue-currency-filter";
import VueCardFormat from 'vue-credit-card-validation';
// import DisableAutocomplete from 'vue-disable-autocomplete';

Vue.config.productionTip = false;

// Vue.use(DisableAutocomplete);
Vue.use(VueCardFormat);
Vue.use(
    VueCurrencyFilter,
    {
        symbol: '$',
        thousandsSeparator: ',',
        fractionCount: 2,
        fractionSeparator: '.',
        symbolPosition: 'front',
        symbolSpacing: false,
        avoidEmptyDecimals: undefined
    }
);

new Vue( {
    router,
    store,
    render: h => h( App )
} ).$mount( "#dvca-anchor" );

